






































































import { Vue, Component, Prop } from "vue-property-decorator";

// Enums / Data
import { ListDisplayMode } from "@/data/constants";

// Types
import { IClient } from "@/models/clients";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "child-accounts-provider": () =>
      import("@/components/app/global/client/childAccountsProvider.vue"),
    "child-accounts-list-item": () =>
      import("@/components/app/global/client/childAccountsListItem.vue")
  }
})
export default class ChildAccountsSection extends Vue {
  // Props
  @Prop({ required: true })
  public clientId!: IClient["id"];

  public gridDisplayMode = ListDisplayMode.GRID;

  public get childAccountsRoute() {
    return {
      name: ClientRoutes.CHILD_ACCOUNTS
    };
  }

  public get client() {
    return this.$store.state.user;
  }
}
